/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для адреса доставки
   */
  app.UserDeliveryAddressView = app.View.extend({
    
    tagName: 'div',
    
    className: 'usr-items-list__item delivery-address',
    
    template: _.template($('#delivery-address-view').text()),
    
    // Обработчики пользовательских событий
    events: {
      'click .remove-delivery-address': 'confirmRemovingAddress',
      'click .edit-delivery-address': 'edit'
    },
    /**
     * @inheritDoc
     */
    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      this.$el.attr('data-delivery-address-id', this.model.id);
      if (app.isMobile) {
        this.addPopupControls();
      }
      return this;
    },
        /**
     * @inheritDoc
     */
    run: function () {
      this.confirmButton = document.querySelectorAll('.confirm-rm-address');
      if (app.isMobile) {
        this.addPopupControls();
      }
    },

    /**
     * Создать попап с кнопками управления
     */
    addPopupControls: function() {
      this.childViews.popupDeliveryAddressControlsView = new app.РopupDeliveryAddressControlsView({
          opener: this.$el.find('.js-opener-delivery-address'),
          model: this.model,
          owner: this,
        });
    },

    /**
     * Подтвердить удаление адреса
     */
    confirmRemovingAddress: function () {
      var modelId = this.model.id;
      $(this.confirmButton).attr('data-address-model-id', modelId);
    },

    /**
     * Подтвердить редактирование адреса
     */
    edit: function () {
      this.trigger('edit-delivery-address-view', this.model);
    }
  });
})(jQuery);

}.call(window));